// extracted by mini-css-extract-plugin
export default {"circle":"UserInitials_circle__q6+T1","text":"UserInitials_text__A93L3"};